import { useQuery } from "@tanstack/react-query";

import keys from "../keys";

const body = {
	Division: "SA",
	ValidFrom: "2025-05-31T00:00:00.000Z",
	ValidTo: "2025-06-30T00:00:00.000Z",
	ProductCode: "P1",
	ProductType: "Investment",
	ContractStatusType: "New",
	ContractCreationType: "Paper",
};

export type DocumentRule = {
	DocumentType: string;
	IsSendToClientRequired: boolean;
	IsCLientSignatureRequired: boolean;
	IsSendToBORequired: boolean;
	IsAutoCheckRequired: boolean;
	IsBOArchivationRequired: boolean;
	IsSendToPartnerRequired: boolean;
	IsCheckAgainstMeetingRecordRequired: boolean;
};

const documentRule: DocumentRule = {
	DocumentType: "Smlouva",
	IsSendToClientRequired: true,
	IsCLientSignatureRequired: true,
	IsSendToBORequired: true,
	IsAutoCheckRequired: true,
	IsBOArchivationRequired: true,
	IsSendToPartnerRequired: true,
	IsCheckAgainstMeetingRecordRequired: true,
};

export const useDocumentRulesQuery = () => {
	return useQuery<DocumentRule>({
		queryKey: keys.documentRules,
		queryFn: async () => {
			try {
				const response = await fetch(
					"https://h8kss8cskswgkskk00w4gckk.cloud.blogic.cz/webservice/ProductionSumbissionRules/ProductionSumbissionRules/RequiredDocuments",
					{
						method: "POST",
						body: JSON.stringify(body),
						headers: {
							"content-type": "application/json",
						},
					},
				);
				const data = await response.json();
				return data;
			} catch (_error) {
				return documentRule;
			}
		},
		staleTime: 0,
	});
};
